import type { SVGProps } from 'react'
const SvgSyTechSolidCloudEndpoints = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M15 10H9l-1 2 1 2h6l1-2z" />
		<path fillOpacity={0.24} d="m16 12-1-2H9l-1 2z" />
		<path d="M18 6h-3l3.97 6 1.5-2.25z" />
		<path fillOpacity={0.24} d="m21.95 12-1.48-2.25-1.5 2.25L15 18h3z" />
		<path d="M5.95 18h3l-3.97-6-1.5 2.25z" />
		<path fillOpacity={0.24} d="m2 12 1.48 2.25L4.98 12l3.97-6h-3z" />
	</svg>
)
export default SvgSyTechSolidCloudEndpoints
